export const environment = {
  baseUrl: 'https://diia-business-admin-feat-export-market-tool.demo.ukrohost.com',
  production: true,
  api: {
    url: 'https://diia-business-backend-feat-export-market-tool.demo.ukrohost.com',
    routes: {
      api: 'api',
      auth: 'auth',
      admin: 'admin',
      front: 'front',
    },
  },
  front: {
    url: 'https://diia-business-feat-export-market-tool.demo.ukrohost.com',
  },
  tinymce: {
    apiKey: '7kpnpy5q7k1b2tgi5xctxmcxmna70gi20otw4ozj0h62b1fy',
  },
};
